import { isLocalhostDebug } from './debug/localDevLogger';

const AUTH_DEBUG_KEY = 'auth_debug_enabled';

export const isAuthDebugEnabled = () => {
  if (!isLocalhostDebug()) return false;
  try {
    return window?.localStorage?.getItem(AUTH_DEBUG_KEY) === 'true';
  } catch {
    return false;
  }
};

export const setAuthDebugEnabled = (enabled) => {
  try {
    window?.localStorage?.setItem(AUTH_DEBUG_KEY, enabled ? 'true' : 'false');
  } catch {
    // ignore
  }
};

const safeSessionSummary = (session) => {
  if (!session) return null;
  return {
    hasAccessToken: Boolean(session.access_token),
    hasRefreshToken: Boolean(session.refresh_token),
    expiresAt: session.expires_at,
    userId: session.user?.id || null,
    email: session.user?.email || null,
  };
};

export const logAuthDebug = (label, payload = {}) => {
  if (!isAuthDebugEnabled()) return;
  try {
    const data = {
      label,
      at: new Date().toISOString(),
      ...payload,
    };
    if (data.session) {
      data.session = safeSessionSummary(data.session);
    }
    if (data.sessionData?.session) {
      data.sessionData = {
        ...data.sessionData,
        session: safeSessionSummary(data.sessionData.session),
      };
    }
    try {
      const store = window.__authDebugLogs;
      if (Array.isArray(store)) {
        store.push(data);
      } else {
        window.__authDebugLogs = [data];
      }
      const maxEntries = 500;
      if (window.__authDebugLogs.length > maxEntries) {
        window.__authDebugLogs = window.__authDebugLogs.slice(-maxEntries);
      }
    } catch {
      // ignore
    }
    console.log('[auth-debug]', data);
  } catch {
    // ignore
  }
};
